import { AppState } from '../../..';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import {
  DocumentHistoryTableComponent,
  DocumentHistoryTableComponentProperties
} from './document-history-table.component';
import { DocumentHistoryState } from '../../document-history.reducer';
import { toggleDialog, toggleModal } from '@common/components/common.actions';
import { getDocumentHistory } from 'src/document-history/document-history.actions';
import { ModalProps } from '@common/components';

// This is used to translate the state of the page to the props on the component
function mapStateToProps(
  state: AppState,
  ownProps: { entityId: number }
): Partial<DocumentHistoryTableComponentProperties> {
  return {
    entityId: ownProps.entityId,
    message: state.documentHistory.message,
    documentsLoading: state.documentHistory.documentsLoading,
    documents: state.documentHistory.documents
  };
}

// This should create proxy wrappers for actions used by the component
function mapDispatchToProps(
  dispatch: Dispatch<DocumentHistoryState>
): Partial<DocumentHistoryTableComponentProperties> {
  return {
    getDocumentHistory: entityId => dispatch(getDocumentHistory(entityId)),
    toggleDialog: (comment: string) => {
      dispatch(toggleDialog({ textYes: 'Close', text: comment, onYesClick: () => toggleDialog() }));
    },
    toggleModal: (modalProps?: ModalProps) => {
      dispatch(toggleModal(modalProps));
    }
  };
}

// Connect function "wires" both of the map functions and returns a wrapper container for the component
export const DocumentHistoryTable = connect(
  mapStateToProps,
  mapDispatchToProps
)(DocumentHistoryTableComponent);



// WEBPACK FOOTER //
// ./src/document-history/_components/document-history-table/document-history-table.container.ts